import React, { useState } from 'react';
import { Form, Input, Button, Card, message, Modal } from 'antd';
import { UserOutlined, LockOutlined, SafetyOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const Login: React.FC = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [adminModalVisible, setAdminModalVisible] = useState(false);

  const onIpaLogin = async (values: { username: string; password: string }) => {
    setLoading(true);
    try {
      await login(values.username, values.password, 'freeipa');
      message.success('登录成功');
      navigate('/dashboard');
    } catch (error: any) {
      console.error('登录错误:', error);
      const errorMessage = error?.error || error?.message || '登录失败，请检查用户名和密码';
      // 使用Modal弹框显示错误
      Modal.error({
        title: '登录失败',
        content: errorMessage,
        okText: '确定',
      });
    } finally {
      setLoading(false);
    }
  };

  const onAdminLogin = async (values: { username: string; password: string }) => {
    // 只允许admin账户登录
    if (values.username !== 'admin') {
      Modal.error({
        title: '登录失败',
        content: '只有管理员账户可以从此入口登录',
        okText: '确定',
      });
      return;
    }

    setLoading(true);
    try {
      await login(values.username, values.password, 'local');
      message.success('管理员登录成功');
      navigate('/admin');
    } catch (error: any) {
      console.error('登录错误:', error);
      const errorMessage = error?.error || error?.message || '登录失败，请检查用户名和密码';
      Modal.error({
        title: '登录失败',
        content: errorMessage,
        okText: '确定',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <Card 
        className="login-card" 
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
            <span style={{ 
              color: '#1e3c72', 
              fontSize: '24px', 
              fontWeight: '700',
              letterSpacing: '1px'
            }}>
              Raina
            </span>
            <span style={{ 
              fontSize: '20px', 
              fontWeight: '400', 
              color: '#1e3c72' 
            }}>
              FTP审核系统
            </span>
          </div>
        }
      >
        <Form
          name="ipaLogin"
          onFinish={onIpaLogin}
          autoComplete="off"
          size="large"
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: '请输入用户名' }]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="IPA用户名"
            />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="IPA密码"
            />
          </Form.Item>
          <Form.Item>
            <div style={{ marginBottom: 16, color: '#999', fontSize: '12px' }}>
              忘记IPA密码？请联系IT部门（kangzijin@raina.tech）
            </div>
            <Button
              type="primary"
              htmlType="submit"
              block
              loading={loading}
            >
              登录
            </Button>
          </Form.Item>
        </Form>

        <div style={{ marginTop: 24, textAlign: 'center', borderTop: '1px solid #f0f0f0', paddingTop: 16 }}>
          <Button
            type="link"
            icon={<SafetyOutlined />}
            onClick={() => setAdminModalVisible(true)}
          >
            管理员入口
          </Button>
        </div>
      </Card>

      <Modal
        title="管理员登录"
        open={adminModalVisible}
        onCancel={() => setAdminModalVisible(false)}
        footer={null}
        width={400}
      >
        <Form
          name="adminLogin"
          onFinish={onAdminLogin}
          autoComplete="off"
          size="large"
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: '请输入管理员用户名' }]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="管理员用户名"
            />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="管理员密码"
            />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
              loading={loading}
            >
              登录
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Login;
